import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import { withFieldProps } from 'hooks/useFieldProps';
import RawHtml from 'common/RawHtml';

import selectorStyles from './styles/selector';

const styles = (theme) => {
  const rootStyles = selectorStyles(theme);
  return {
    root: {
      ...rootStyles,
      '& button': {
        ...rootStyles['& button'],
        cursor: 'pointer',
        padding: [0, theme.spacing.unit * 2],
      },
    },
  };
};

const Toggle = ({ classes, fieldDescr, name, onChange, options, value }) => {
  const itemsRef = useRef([]);

  useEffect(() => {
    if (!value) {
      onChange(name, options[0].value);
    }
  }, [name, onChange, options, value]);
  return (
    <>
      <div className={classnames('toggle-fieldView', classes.root)} role="tablist">
        {options.map((option, i) => (
          <button
            key={option.value}
            type="button"
            data-value={option.value}
            role="tab"
            ref={(el) => {
              itemsRef.current[i] = el;
            }}
            aria-controls={`panel${i}`}
            id={`tab${i}`}
            aria-selected={value && option.value === value}
            className={classnames({
              active: value && option.value === value,
            })}
            onClick={() => onChange(name, option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
      {fieldDescr && <RawHtml>{fieldDescr}</RawHtml>}
    </>
  );
};

Toggle.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  fieldDescr: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
    }).isRequired,
  ).isRequired,
  value: PropTypes.string.isRequired,
};

const ToggleStyled = withStyles(styles)(Toggle);

const mapStateToProps = ({ fields }, { name }) => {
  const field = fields[name];
  return {
    options: field.selectorValues,
  };
};

export default withFieldProps(mapStateToProps)(ToggleStyled);
